/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Edit_Imprint_TitleInputs */

const en_admin_edit_imprint_title = /** @type {(inputs: Admin_Edit_Imprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprint`)
};

const de_admin_edit_imprint_title = /** @type {(inputs: Admin_Edit_Imprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressum`)
};

/**
* | output |
* | --- |
* | "Imprint" |
*
* @param {Admin_Edit_Imprint_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_edit_imprint_title = /** @type {((inputs?: Admin_Edit_Imprint_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Edit_Imprint_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_edit_imprint_title(inputs)
	return en_admin_edit_imprint_title(inputs)
});